<form [formGroup]="formGroup" class="fim">
  @if (pageTitle) {
    <div class="fim-page-header">
      <b>{{ getQuestionTitle(pageTitle) }}</b>
      @if (getQuestionInstruction(pageTitle)) {
        <div class="fim-instruction">
          {{ getQuestionInstruction(pageTitle) }}
        </div>
      }
    </div>
  }
  @for (element of elements; track element.name) {
    @if (element.type === "section") {
      <div class="section">
        <b class="section-title">{{ getQuestionTitle(element.title) }}</b>
        @if (getQuestionInstruction(element.title)) {
          <div class="fim-instruction">
            {{ getQuestionInstruction(element.title) }}
          </div>
        }
      </div>
    }
    @if (element.type === "radiogroup" && !isModeElement(element)) {
      <div class="fim-row">
        <div class="fim-q">
          <div class="fim-q-title">
            <span>{{ getQuestionTitle(element.title) }}</span>
          </div>
          @if (getQuestionInstruction(element.title)) {
            <div class="fim-instruction">
              {{ getQuestionInstruction(element.title) }}
            </div>
          }
        </div>

        <div class="fim-a">
          <div class="fim-group">
            @for (choice of element.choices; track choice.value) {
              <label class="fim-option">
                <input
                  type="radio"
                  [formControlName]="element.name"
                  [value]="choice.value"
                  (click)="onRadioClick(element.name, choice.value)"
                />
                <span class="fim-option-text">{{
                  choice.text
                }}</span>
              </label>
            }
          </div>

          @if (getModeElement(element); as mode) {
            <div class="fim-mode">
              <div class="fim-mode-title">
                {{ getQuestionTitle(mode.title) }}
              </div>
              <div class="fim-mode-group">
                @for (choice of mode.choices; track choice.value) {
                  <label class="fim-option fim-mode-option">
                    <input
                      type="radio"
                      [formControlName]="mode.name"
                      [value]="choice.value"
                      (click)="onRadioClick(mode.name, choice.value)"
                    />
                    <span class="fim-option-text">{{
                      choice.text
                    }}</span>
                  </label>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }
    @if (isScoreElement(element)) {
      <div class="fim-score" [class.fim-total]="isTotalScoreElement(element)">
        <div class="fim-score-title">
          {{ getQuestionTitle(element.title) }}
        </div>
        <div class="fim-score-value">
          {{ getScoreDisplay(element.name) }} /
          {{ getMaxScore(element.name) }}
        </div>
      </div>
    }
  }
</form>
